module.exports = __webpack_public_path__ + "img/636.d4a84c1f.png";